import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { Link, useLocation } from "react-router-dom";
export default function StaffLink({ token }: { token?: string }) {
  const [approvedToken, setApprovedToken] = useState<string | null>(null);
  const [open, setOpen] = useState(false);
  const root = useRef<HTMLDivElement>(null);
  const button = useRef<HTMLButtonElement>(null);
  const location = useLocation();
  useEffect(() => { setOpen(false); }, [location.pathname, location.search, token]);
  useEffect(() => {
    if (!open) return;
    const dismiss = (event: PointerEvent) => { if (!root.current?.contains(event.target as Node)) setOpen(false); };
    document.addEventListener("pointerdown", dismiss);
    return () => document.removeEventListener("pointerdown", dismiss);
  }, [open]);
  useEffect(() => {
    let active = true;
    setApprovedToken(null);
    if (token) axios.get(`${process.env.REACT_APP_SERVER_URL}/admin/access`, { headers: { Authorization: `Bearer ${token}` } })
      .then(() => { if (active) setApprovedToken(token); }).catch(() => {});
    return () => { active = false; };
  }, [token]);
  return token && approvedToken === token ? (
    <div className="sh-admin" ref={root} onBlur={event => {
      if (!event.currentTarget.contains(event.relatedTarget as Node)) setOpen(false);
    }} onKeyDown={event => {
      if (event.key === "Escape" && open) { event.stopPropagation(); setOpen(false); button.current?.focus(); }
    }}>
      <button className={`sh-admin-trigger ${(location.pathname === '/admin' || location.pathname.startsWith('/admin/')) ? 'is-active' : ''}`} ref={button} type="button" aria-expanded={open} aria-controls="admin-navigation-links" onClick={() => setOpen(value => !value)}>
        Admin <span aria-hidden="true">{open ? '▴' : '▾'}</span>
      </button>
      {open && <div id="admin-navigation-links" className="sh-admin-links" onClick={() => setOpen(false)}>
        <Link to="/admin">Dashboard</Link>
        <Link to="/admin/orders">Manage orders</Link>
        <Link to="/admin/products">Product manager</Link>
        <Link to="/admin/customers">Customers</Link>
        <Link to="/admin/quotes">Quote requests</Link>
        <Link to="/admin/reports">Sales report</Link>
        <Link to="/admin/stock">Low stock</Link>
        <Link to="/admin/abandoned-carts">Abandoned checkouts</Link>
        <Link to="/admin/payments">Reconcile payments</Link>
      </div>}
    </div>
  ) : null;
}
